<div class="flex justify-end items-end flex-wrap gap-2 mb-4">
  <!-- <nz-page-header nzTitle="Environment Management"> Excursion Management</nz-page-header> -->
  <button nz-button nzType="primary" type="button" (click)="openFormModal()"><i nz-icon nzType="plus"></i>
    Add Excursion
  </button>
</div>

<nz-table #filterTable nzShowSizeChanger [nzData]="excursionsList" nzTableLayout="fixed" [nzLoading]="isLoading"
  [nzScroll]="{ x: '1024px', y: '35dvh' }" [nzSize]="'small'" [nzPaginationType]="'small'" [nzShowTotal]="totalTemplate"
  >
  <thead>
    <tr>
      @for (column of listOfColumns; track column) {
      <th>
        {{ column.name }}
      </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (data of filterTable.data; track data.reason_id) {
    <tr>
      <td>{{ data.reason_id }}</td>
      <td>{{ data.reason_of_exceursion }}</td>
      <td nzEllipsis="...">
        <span nz-tooltip="Edit" [nzTooltipColor]="'#fff'" nz-icon nzType="edit" nzTheme="outline"
          class="text-base text-primary cursor-pointer" (click)="openEditModal(data)"></span>
        <span nz-tooltip="Delete" [nzTooltipColor]="'#fff'" nz-icon nzType="delete" nzTheme="outline"
          class="text-base text-danger cursor-pointer ml-5" nz-popconfirm nzPopconfirmPlacement="bottom"
          nzPopconfirmTitle="Are you sure to remove this record?" (nzOnConfirm)="deleteExcursion(data.reason_id)"></span>
      </td>
    </tr>
    }
  </tbody>
</nz-table>

<nz-modal [(nzVisible)]="isFormModalVisible" [nzTitle]="isEditMode ? 'Edit Excursion' : 'Add Excursion'"
  (nzOnCancel)="isFormModalVisible=false" [nzFooter]="modalFooter" nzWidth="500px">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="excursionForm" (ngSubmit)="submitForm()">
      <nz-form-item class="mb-4">
        <nz-form-label [nzSpan]="24" nzFor="excursionReason" nzRequired>
          <span class="inline-block">Excursion Reason</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24" nzErrorTip="Please enter an excursion reason">
          <ng-container *ngIf="isEditMode; else selectMode">
            <input nz-input id="reason_of_exceursion" formControlName="reason_of_exceursion"
              placeholder="Enter Excursion Reason" />
          </ng-container>
          <ng-template #selectMode>
            <nz-select id="reason_of_exceursion" formControlName="reason_of_exceursion" nzPlaceHolder="Select Excursion"
              nzShowSearch nzShowArrow="false">
              <nz-option *ngFor="let exr of excursionOptions" [nzLabel]="exr.reason_of_exceursion"
                [nzValue]="exr.reason_of_exceursion"></nz-option>
            </nz-select>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>

  <ng-template #modalFooter>
    <div class="flex justify-end gap-2">
      <button nz-button nzType="default" (click)="isFormModalVisible=false">Cancel</button>
      <button nz-button nzType="primary" [nzLoading]="isLoading" (click)="submitForm()">
        {{ isEditMode ? 'Update' : 'Save' }}
      </button>
    </div>
  </ng-template>
</nz-modal>
<ng-template #totalTemplate let-total>Showing {{ total }} items</ng-template>